/**
 * Main Collection Page
 * - Top filter bar dropdown toggles
 * - Sort select → auto-submit (append sort_by to URL)
 * - Load More (AJAX, appends products)
 * - Infinite scroll (IntersectionObserver)
 */

(function () {
  'use strict';

  /* ════════════════════════════════════════════
     Vue liste / grille (toggle + localStorage)
     ════════════════════════════════════════════ */

  (function () {
    var grid    = document.querySelector('[data-grid]');
    var toggle  = document.querySelector('[data-view-toggle]');
    if (!grid || !toggle) return;

    var STORAGE_KEY = 'stratos-collection-view';
    var btns = toggle.querySelectorAll('[data-view]');

    function setView(view) {
      var isList = view === 'list';
      grid.classList.toggle('is-list-view', isList);
      btns.forEach(function (btn) {
        var active = btn.dataset.view === view;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      try { localStorage.setItem(STORAGE_KEY, view); } catch (_) {}
    }

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () { setView(btn.dataset.view); });
    });

    /* Restaurer la préférence sauvegardée */
    try {
      var saved = localStorage.getItem(STORAGE_KEY);
      if (saved === 'list' || saved === 'grid') setView(saved);
    } catch (_) {}
  })();

  /* ════════════════════════════════════════════
     Sort select
     ════════════════════════════════════════════ */

  document.querySelectorAll('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ════════════════════════════════════════════
     Top filter bar — dropdown toggles
     ════════════════════════════════════════════ */

  var facetsTop = document.querySelector('[data-facets-top]');

  if (facetsTop) {
    var triggers = facetsTop.querySelectorAll('[data-filter-trigger]');

    function closeAll(except) {
      triggers.forEach(function (t) {
        if (t === except) return;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        t.setAttribute('aria-expanded', 'false');
        if (panel) { panel.setAttribute('aria-hidden', 'true'); panel.hidden = true; }
      });
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        closeAll(expanded ? null : trigger);
        if (!expanded) {
          var panel = document.getElementById(trigger.getAttribute('aria-controls'));
          trigger.setAttribute('aria-expanded', 'true');
          if (panel) { panel.setAttribute('aria-hidden', 'false'); panel.hidden = false; }
        } else {
          trigger.setAttribute('aria-expanded', 'false');
          var panel = document.getElementById(trigger.getAttribute('aria-controls'));
          if (panel) { panel.setAttribute('aria-hidden', 'true'); panel.hidden = true; }
        }
      });
    });

    /* Close on outside click */
    document.addEventListener('click', function () { closeAll(null); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });
  }

  /* ════════════════════════════════════════════
     AJAX pagination (Load More + Infinite Scroll)
     ════════════════════════════════════════════ */

  /* `[data-section-id]` n'est pas unique à cette section (header,
     sticky-atc, featured-product l'utilisent aussi) et le header apparaît
     avant le contenu de la page dans le DOM (layout/theme.liquid) : le
     querySelector remontait systématiquement le header en premier, donc
     `loadBtn` valait toujours null et le clic sur "Charger plus" ne
     déclenchait jamais loadNextPage(). `[data-pagination]` n'est posé que
     sur ce wrapper de section, il est unique. Bug repéré sept. 2026. */
  var section = document.querySelector('[data-pagination]');
  if (!section) return;

  var paginationType = section.dataset.pagination;
  if (paginationType === 'pages') return;

  var grid       = section.querySelector('[data-grid]');
  var loadMore   = section.querySelector('[data-load-more]');
  var loadBtn    = section.querySelector('[data-load-more-btn]');
  var sentinel   = section.querySelector('[data-sentinel]');
  var isLoading  = false;

  function getNextUrl() {
    var el = section.querySelector('[data-next-url]');
    return el ? el.dataset.nextUrl : null;
  }

  function setNextUrl(url) {
    var els = section.querySelectorAll('[data-next-url]');
    els.forEach(function (el) { el.dataset.nextUrl = url || ''; });
  }

  function extractGridItems(html) {
    var parser = new DOMParser();
    var doc    = parser.parseFromString(html, 'text/html');
    return doc.querySelectorAll('[data-grid] .product-grid__item');
  }

  function extractNextUrl(html) {
    var parser = new DOMParser();
    var doc    = parser.parseFromString(html, 'text/html');
    var el     = doc.querySelector('[data-next-url]');
    return el ? el.dataset.nextUrl : null;
  }

  function loadNextPage() {
    var nextUrl = getNextUrl();
    if (!nextUrl || isLoading) return;
    isLoading = true;

    if (loadBtn) loadBtn.classList.add('is-loading');

    fetch(nextUrl)
      .then(function (r) {
        if (!r.ok) throw new Error('Network error');
        return r.text();
      })
      .then(function (html) {
        var items   = extractGridItems(html);
        var newNext = extractNextUrl(html);

        /* Append items with a small fade-in */
        items.forEach(function (item, i) {
          item.style.opacity    = '0';
          item.style.transform  = 'translateY(12px)';
          item.style.transition = 'opacity 300ms ease ' + (i * 40) + 'ms, transform 300ms ease ' + (i * 40) + 'ms';
          grid.appendChild(item);
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              item.style.opacity   = '1';
              item.style.transform = 'translateY(0)';
            });
          });
        });

        /* Update next URL */
        setNextUrl(newNext);

        /* Update / hide load-more UI */
        if (!newNext) {
          if (loadMore) loadMore.remove();
        } else {
          if (loadBtn) {
            loadBtn.dataset.nextUrl = newNext;
            loadBtn.classList.remove('is-loading');
          }
          if (sentinel) sentinel.dataset.nextUrl = newNext;
        }

        /* Update URL bar without reload */
        try {
          var urlObj = new URL(nextUrl, window.location.origin);
          history.replaceState(null, '', urlObj.pathname + urlObj.search);
        } catch (e) {}
      })
      .catch(function (err) {
        console.warn('[Collection] Load more failed:', err);
        if (loadBtn) loadBtn.classList.remove('is-loading');
      })
      .finally(function () {
        isLoading = false;
      });
  }

  /* ── Load More button ── */
  if (loadBtn) {
    loadBtn.addEventListener('click', loadNextPage);
  }

  /* ── Infinite scroll sentinel ── */
  if (paginationType === 'infinite' && sentinel && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) loadNextPage();
      });
    }, { rootMargin: '300px' });

    observer.observe(sentinel);
  }

})();
